import React from 'react';
import PrepRequestContent from './content';
import PrepTeamRequestProvider from 'contexts/kitchen/prep-team-request.context/provider';

const PrepRequestLayout = () => {
  return (
    <PrepTeamRequestProvider>
      <PrepRequestContent />
    </PrepTeamRequestProvider>
  );
};

export default PrepRequestLayout;
